import React from "react";
import BlockContent from "@sanity/block-content-to-react";
import clsx from "clsx";
import SanityImage from "./SanityImage";
import ProductEmbed from "./shop/ProductEmbed";
// import VideoEmbed from "./ui/VideoEmbed";
import { VideoWrapper } from "./ui/player";

const SanityPortableText = ({ input, indentP = false }) => {
  // console.log(input);
  const serializers = {
    types: {
      block(props) {
        // console.log(props.node);
        switch (props.node.style) {
          // case "h1":
          //   return <h1>{props.children}</h1>
          default:
            return (
              <p
                className={clsx(
                  indentP ? "pl-50 md:pl-2/6 pr-sm md:pr-md" : ""
                )}>
                {props.children}
              </p>
            );
        }
      },
      productEmbed: ({ node }) => {
        return (
          <div className='overflow-'>
            <div className='-mx-md'>
              <ProductEmbed input={node.product} />
            </div>
          </div>
        );
      },
      imageEmbed: ({ node }) => {
        // console.log(node);
        return (
          <div className='overflow-'>
            <div className='-mx-md'>
              <SanityImage input={node} />
            </div>
          </div>
        );
      },
      videoEmbed: ({ node }) => {
        // console.log(node);
        return (
          <div className='overflow-'>
            <div className='-mx-md mb-md'>
              <VideoWrapper video_url={node.url} />
            </div>
          </div>
        );
      }
    },

    marks: {
      link: ({ mark, children }) => {
        // Read https://css-tricks.com/use-target_blank/
        // console.log(mark);
        const { blank, href } = mark;
        return blank ? (
          <a href={href} target='_blank' rel='noopener, noreferrer'>
            {children}
          </a>
        ) : (
          <a href={href}>{children}</a>
        );
      }
    }
  };

  return (
    <div className='sanity-portable-texte '>
      <BlockContent blocks={input} serializers={serializers} />
    </div>
  );
};

export default SanityPortableText;
